// extracted by mini-css-extract-plugin
export default {"box":"formControl_box__273g-"};